export const EXPENSE_CLAIM_TYPE = {
  PRE_APPROVED: "pre_approved",
  POST: "post",
};

export const EXPENSE_CLAIM_STATUS = {
  DRAFT: "draft",
  PENDING_HOD: "pending_hod",
  PROOF_PENDING: "proof_pending",
  PENDING_RECONCILIATION: "pending_reconciliation",
  ESCALATED_SA: "escalated_sa",
  FINAL_APPROVED: "final_approved",
  REJECTED: "rejected",
};

export const STATUS_LABELS = {
  draft: "Draft",
  pending_hod: "Pending HOD",
  proof_pending: "Awaiting proof",
  pending_reconciliation: "Pending reconciliation",
  escalated_sa: "Escalated",
  final_approved: "Approved",
  rejected: "Rejected",
};

export const TYPE_LABELS = {
  pre_approved: "Pre-approved",
  post: "Post-event",
};

export const STATUS_COLORS = {
  draft: { bg: "#f1f5f9", color: "#475569" },
  pending_hod: { bg: "#fef3c7", color: "#b45309" },
  proof_pending: { bg: "#e0e7ff", color: "#4338ca" },
  pending_reconciliation: { bg: "#fce7f3", color: "#be185d" },
  escalated_sa: { bg: "#ffedd5", color: "#c2410c" },
  final_approved: { bg: "#dcfce7", color: "#15803d" },
  rejected: { bg: "#fee2e2", color: "#b91c1c" },
};
